import { z } from "zod";
import { BMDropdownOptionsValue } from "../../../components";

export type FormOptions = {
  data: {
    role: BMDropdownOptionsValue[];
    division: BMDropdownOptionsValue[];
    policy: BMDropdownOptionsValue[];
  };
  loading: {
    role: boolean;
    division: boolean;
    policy: boolean;
  };
  error: {
    role: string | null;
    division: string | null;
    policy: string | null;
  };
  refetch: {
    role: () => void;
    division: () => void;
    policy: () => void;
  };
};

export const AddUpdateEmployeeSchema = z.object({
  fullname: z.string(),
  email: z.string(),
  phone: z
    .object({
      prefix: z.string(),
      phone: z.string(),
    })
    .nullable(),
  role: z.string(),
  policy: z.string(),
  division: z.string().nullable(),
  birthdate: z.date().nullable(),
  nationality: z.string().nullable(),
  identityCardNumber: z.string().nullable(),
  passportNumber: z.string().nullable(),
  passportExpirationDate: z.date().nullable(),
  passportCountryOfIssuance: z.string().nullable(),
});

export type AddUpdateEmployeeFormValues = z.infer<
  typeof AddUpdateEmployeeSchema
>;
